module.exports = __webpack_public_path__ + "static/img2-d399e66ba40e15d8ac839d09d75c9689.png";